import {
  loginLoginIdSchema,
  loginMailAddressSchema,
  loginPasswordSchema,
} from './login';
import {
  password,
  passwordAnycase,
} from './regex';

import { EAccountPasswordCharacterType } from '@/types';
import {
  InferType,
  object,
  string,
} from '@/validations/custom-yup';

/**
 * パスワード
 * - xx~70文字
 * - 半角英数字記号
 * - 最低1文字含まないといけない文字種はpasswordCharacterTypeに依存.
 *   - ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED: 標準
 *   - ALPHANUMERIC_ANYCASE: 7月Verup②時点での加盟店アプリに寄せた形
 * - 記号は!"#$%&'()*+,-./:;<=>?@[¥]^_`{|}~のみ許可(任意)
 */
export const createPasswordSchema = (passwordMinDigits: number, passwordCharacterType: 'ALPHANUMERIC_ANYCASE' | 'ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED') => {
  const baseSchema = string()
    .label('パスワード')
    .required(({ label }) => `${label}を入力してください。`)
    .min(passwordMinDigits, `パスワードは${passwordMinDigits}~70文字で入力してください。`)
    .max(70, `パスワードは${passwordMinDigits}~70文字で入力してください。`);

  const errorMessage = `パスワードは半角英数字記号で入力してください。${EAccountPasswordCharacterType[passwordCharacterType]}`;
  const regex = passwordCharacterType === 'ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED' ? password : passwordAnycase;
  return baseSchema.matches(regex, errorMessage);
};
export const sendPasswordResetMailFormSchema = object({
  loginId: loginLoginIdSchema,
  mailAddress: loginMailAddressSchema,
});

export const createPasswordChangeFormSchema = (passwordMinDigits: number, passwordCharacterType: 'ALPHANUMERIC_ANYCASE' | 'ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED') => object({
  password: createPasswordSchema(passwordMinDigits, passwordCharacterType),
});

export const createPasswordUpdateFormSchema = (passwordMinDigits: number, passwordCharacterType: 'ALPHANUMERIC_ANYCASE' | 'ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED') => object({
  password: loginPasswordSchema,
  newPassword: createPasswordSchema(passwordMinDigits, passwordCharacterType),
});

export type CreatePassword = InferType<ReturnType<typeof createPasswordSchema>>;
export type CreatePasswordChangeForm = InferType<ReturnType<typeof createPasswordChangeFormSchema>>;
export type CreatePasswordUpdateForm = InferType<ReturnType<typeof createPasswordUpdateFormSchema>>;
export type SendPasswordResetMailForm = InferType<typeof sendPasswordResetMailFormSchema>;
